(() => {
  if (customElements.get('leslis-prien-availability')) return;
  class LeslisPrienAvailability extends HTMLElement {
    connectedCallback() {
      this.disconnect();
      this.abort = new AbortController();
      this.root = this.closest('product-info') || this.closest('.shopify-section');
      this.form = document.getElementById(this.dataset.form);
      this.form?.addEventListener('change', (event) => {
        if (event.target.name !== 'id') return;
        if (!event.target.value) this.invalidate();
        else if (event.target.value !== this.dataset.variant) this.setAttribute('aria-busy', 'true');
      }, { signal: this.abort.signal });
      this.root?.addEventListener('product-info:variant-error', () => this.invalidate(), { signal: this.abort.signal });
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => this.update(data));
      this.unsubscribeOptions = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        if (this.root?.contains(data.event?.target)) this.setAttribute('aria-busy', 'true');
      });
    }

    invalidate() {
      this.hidden = true;
      this.removeAttribute('aria-busy');
    }

    update(data) {
      const section = this.root?.dataset.originalSection || this.root?.dataset.section || this.dataset.section;
      if (String(data.sectionId) !== section) return;
      const variantId = String(data.variant?.id || '');
      const currentId = this.form?.querySelector('[name="id"]')?.value;
      if (!variantId || (currentId !== undefined && currentId !== variantId)) return;
      const fresh = Array.from(data.html?.querySelectorAll('leslis-prien-availability') || []).find((node) =>
        node.dataset.product === this.dataset.product && node.dataset.variant === variantId
      );
      if (!fresh) {
        this.invalidate();
        return;
      }
      this.innerHTML = fresh.innerHTML;
      this.dataset.variant = fresh.dataset.variant;
      this.dataset.ready = fresh.dataset.ready;
      this.hidden = fresh.hidden;
      this.removeAttribute('aria-busy');
    }

    disconnect() {
      this.abort?.abort();
      this.unsubscribeVariant?.();
      this.unsubscribeOptions?.();
    }

    disconnectedCallback() {
      this.disconnect();
    }
  }
  customElements.define('leslis-prien-availability', LeslisPrienAvailability);
})();
